export default function initNotifications() {
    window.Alpine.data('notifications', () => ({
        duration: 5000,
        visible: false,
        type: 'notice',
        message: null,

        init() {
            window.addEventListener('notification', (event) => {
                this.show(event.detail);
            });
        },

        show(options) {
            if (options.type) {
                this.type = options.type;
            }

            if (options.message) {
                this.message = options.message;
            }

            this.visible = true;

            setTimeout(() => {
                this.visible = false;
            }, this.duration);
        }
    }));
}

window.addNotification = function addNotification(type = 'notice', message = null) {
    if (type && message) {
        window.dispatchEvent(new CustomEvent('notification', {
            detail: {
                type,
                message
            }
        }));
    }
};
